export default "__VITE_ASSET__D960$CPW__"